module.exports = __webpack_public_path__ + "media/customizations/emanuel/logo-new-ec795af564c44510bcd000773f80fc1a.png";